import { apiClient, getAuthModule } from '@littlebird/auth-client';
import { queryOptions } from '@tanstack/react-query';
import { millisecondsInMinute } from 'date-fns/constants';
import { z } from 'zod';

import { getLocalStorageItem, setLocalStorageItem } from '@/utils/localStorage';

const RECOMMENDATIONS_LOCAL_STORAGE_KEY = 'RECOMMENDATIONS_LOCAL_STORAGE_KEY';

const RecommendationsSchema = z.object({
  recommended_questions: z.array(z.string()),
});

const FIRST_CHAT_QUESTION_RECOMMENDATIONS = getLocalStorageItem(
  RECOMMENDATIONS_LOCAL_STORAGE_KEY
) ?? [
  'What have I been doing today?',
  'Search for main news on every continent',
  'How can you help me with my work?',
];

const INITIAL_RECOMMENDED_QUESTIONS = {
  recommended_questions: FIRST_CHAT_QUESTION_RECOMMENDATIONS,
};

const INITIAL_RECOMMENDATIONS = RecommendationsSchema.parse({
  ...INITIAL_RECOMMENDED_QUESTIONS,
});

export const getRecommendationsQuery = () =>
  queryOptions({
    queryKey: ['recommendations'],
    enabled: getAuthModule().tokenManager.hasValidToken(),
    initialData: INITIAL_RECOMMENDATIONS,
    queryFn: async () => {
      const data = await apiClient.get('recommended_questions');
      const result = RecommendationsSchema.parse(data);

      setLocalStorageItem(
        RECOMMENDATIONS_LOCAL_STORAGE_KEY,
        result.recommended_questions
      );

      return result;
    },
    refetchInterval: millisecondsInMinute * 1,
    refetchOnWindowFocus: true,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
